/**
 * GallerySkeleton — loading state for the /genies gallery. Six pulsing card
 * shells matching the real GalleryGenieCard layout (disc + name + business +
 * dot + link). Brand law: genie greys only, animate-pulse (house idiom).
 */
const GallerySkeletonCard = () => (
  <div className="flex flex-col items-center rounded-[22px] border border-genie-border bg-white px-[22px] pt-[30px] pb-[26px]">
    <div className="w-[156px] h-[156px] rounded-full bg-gray-100 animate-pulse" />
    <div className="mt-[18px] h-[19px] w-[60%] rounded-full bg-gray-100 animate-pulse" />
    <div className="mt-[10px] h-[13px] w-[45%] rounded-full bg-gray-100 animate-pulse" />
    <div className="mt-[14px] h-[11px] w-[28%] rounded-full bg-gray-100 animate-pulse" />
    <div className="mt-4 h-[13px] w-[40%] rounded-full bg-gray-100 animate-pulse" />
  </div>
);

export const GallerySkeleton = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[26px]">
    {Array.from({ length: 6 }).map((_, i) => (
      <GallerySkeletonCard key={i} />
    ))}
  </div>
);

export default GallerySkeleton;
